/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is
governed by the Apache 2.0 license. */

import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface IProps {
  children: ReactNode;
  className?: string;
  onClick: () => void;
}

const RestocareSubmitButton: FC<IProps> = ({
  children,
  className,
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(styles.wrap, className)}
  >
    {children}
  </button>
);

export { RestocareSubmitButton };
